import React,{ useEffect, useState } from "react";
import DashboardLayout from "../../DashboardLayout";
import { useNavigate, useParams } from "react-router-dom";
import AdsUnitsList from "./adUnitList";
import LoadingSpinner from "../../../Components/spinner";
import { fetchAdUnits } from "../../../services/axios/apiManager";
import { handleErrors } from "../../../services/dataManager";

const AdsUnits = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [adUnits, setAdUnits] = useState([]);
  const [apiName, setApiName] = useState("");
  const [loading, setLoading] = useState(true);

  const getData = async () => {
    const res = await fetchAdUnits(id);
    if (res?.data?.success && res?.data?.data) {
      const { name, ad_units } = res.data.data;
      setAdUnits(ad_units);
      setApiName(name);
    } else {
      handleErrors(res, navigate);
    }
    setLoading(false);
  };
  useEffect(() => {
    if (!id) {
      navigate(-1);
    } else {
      getData();
    }
  }, []);
  return (
    <DashboardLayout>
      {loading ? (
        <div className="d-flex justify-content-center">
          <LoadingSpinner size={"lg"} />
        </div>
      ) : (
        <div>
          <div className="row">
            <div className="col-12 mb-3">
              <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                <div className="page-title-right">
                  <ol className="breadcrumb m-0">
                    <li className="breadcrumb-item">
                      <a>Management</a>
                    </li>
                    <li className="breadcrumb-item">Ad APIs</li>
                    <li className="breadcrumb-item active">{`${apiName || ""} Ad Units`}</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <AdsUnitsList
            adUnits={adUnits}
            getAdUnits={getData}
            adsAPIId={id}
            apiName={apiName}
          />
        </div>
      )}
    </DashboardLayout>
  );
};
export default AdsUnits;
